import { forwardRef, ReactNode } from 'react';
import { LoadingOverlay, Paper, PaperProps } from '@mantine/core';
import clsx from 'clsx';

export type TwContainerProps = {
	children?: ReactNode;
	full?: boolean;
	fill?: boolean;
	className?: string;
	loading?: boolean;
	card?: true;
	xs?: boolean;
	sm?: boolean;
	md?: boolean;
	lg?: boolean;
	xl?: boolean;
	xxl?: boolean;
	huge?: boolean;
	screen?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'huge';
	row?: boolean;
	column?: boolean;
	grid?: boolean;
	id?: string;
} & Omit<PaperProps, 'children' | 'className'>;

export const TwContainer = forwardRef<HTMLDivElement, TwContainerProps>(
	({ id, className, children, loading, screen, grid, column, row, full, fill, xs, sm, md, lg, xl, xxl, huge, card, bg, ...props }, ref) => {
		column = column || (!row && !grid);
		const s = screen ? screen + ':' : '';
		return (
			<Paper
				id={id}
				ref={ref}
				bg={card ? 'var(--mantine-color-default)' : bg || 'transparent'}
				className={clsx(
					'container relative mx-auto flex-grow overflow-hidden',
					{
						'!flex': !grid,
						'!grid': grid,
						'flex-col': column,
						'flex-row': row,
						'w-full max-w-full': full,
						'h-full': fill,
						'max-w-[1400px]': (!full && !xs && !sm && !md && !xl && !xxl && !huge) || lg,
						[s + 'max-w-[540px]']: xs,
						[s + 'max-w-[800px]']: sm,
						[s + 'max-w-[1200px]']: md,
						[s + 'max-w-[1800px]']: xl,
						[s + 'max-w-[2400px]']: xxl,
						[s + 'max-w-[3000px]']: huge,
					},
					className,
				)}
				radius={'md'}
				{...props}>
				<LoadingOverlay
					zIndex={50}
					visible={!!loading}
				/>
				{children}
			</Paper>
		);
	},
);
TwContainer.displayName = 'TwContainer';
